/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { dataLayerPush } from '../helpers/dataLayer';

import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import { Breadcrumb, Footer, Navbar } from '../components';

import { addItemToLocalStorage } from '../helpers/handleCartLocalStorage';
import { Link } from 'react-router-dom';

const ProductsByCategory = () => {
  const [dataByCategory, setDataByCategory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [state, setState] = useState(localStorage.getItem('cart') ? JSON.parse(localStorage.getItem('cart')) : []);
  let componentMounted = true;

  const addProduct = (product) => {
    addItemToLocalStorage(product);
    setState(JSON.parse(localStorage.getItem('cart')));
    dataLayerPush({
      event: 'addToCart',
      pageName: 'home',
      pageType: 'listing',
      product: product,
    });
  };

  useEffect(() => {
    const categoryMappings = {
      '/category/men': 'men',
      '/category/women': 'women',
      '/category/accessories': 'accessories',
      '/category/new-arrivals': 'new-arrivals',
    };

    const pathname = window.location.pathname;
    const selectedCategory = categoryMappings[pathname] || '';

    setSelectedCategory(selectedCategory);
    dataLayerPush({
      event: 'pageView',
      pageType: 'listing',
      pageName: selectedCategory,
    });
  }, []);

  useEffect(() => {
    const getProducts = async () => {
      setLoading(true);
      const response = await fetch('/product.json', {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      });
      if (componentMounted) {
        setDataByCategory(await response.json());
        setLoading(false);
      }
    };

    getProducts();
  }, [componentMounted]);

  const Loading = () => {
    return (
      <>
        <div className='col-12 py-5 text-center'>
          <Skeleton />
        </div>
        <div className='col-md-4 col-sm-6 col-xs-8 col-12 mb-4'>
          <Skeleton />
        </div>
        <div className='col-md-4 col-sm-6 col-xs-8 col-12 mb-4'>
          <Skeleton />
        </div>
        <div className='col-md-4 col-sm-6 col-xs-8 col-12 mb-4'>
          <Skeleton />
        </div>
        <div className='col-md-4 col-sm-6 col-xs-8 col-12 mb-4'>
          <Skeleton />
        </div>
        <div className='col-md-4 col-sm-6 col-xs-8 col-12 mb-4'>
          <Skeleton />
        </div>
        <div className='col-md-4 col-sm-6 col-xs-8 col-12 mb-4'>
          <Skeleton />
        </div>
      </>
    );
  };

  const ShowProducts = () => {
    return (
      <>
        {dataByCategory
          .filter((item) => item.category === selectedCategory)
          .map((product) => {
            return (
              <div id={product.id} key={product.id} className='col-md-3 col-sm-6 col-xs-8 col-12 py-3'>
                <div className='card h-100 border-0 product-card' key={product.id}>
                  <Link to={'/product/' + product.id} className='stretched-link' />
                  <img src={`${product.images.main}`} className='rounded-1' alt='main image' />
                  <button
                    className='btn btn-light w-75 mx-auto m-1 addToCart bottom-10 position-relative btn-sm border-0'
                    style={{ bottom: '8%', zIndex: 1 }}
                    onClick={(e) => {
                      e.preventDefault();
                      addProduct(product);
                    }}>
                    Add to Cart
                  </button>
                  <div className='d-flex'>
                    <p className='mb-0 fw-light'>{product.title}</p>
                    <p className='ms-auto mb-0 fw-light'>{product.sub}</p>
                  </div>
                  <div className='d-flex'>
                    <p className='mt-0'>$ {product.price}</p>
                    <a href={'/product/' + product.id} className='ms-auto mt-0 primary-color'>
                      Buy Now
                    </a>
                  </div>
                </div>
              </div>
            );
          })}
      </>
    );
  };
  return (
    <>
      <Navbar />
      <div className='container my-5 py-2'>
        <div className='row'>
          <Breadcrumb category={selectedCategory} />
          {loading ? <Loading /> : <ShowProducts />}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ProductsByCategory;
